/**
 * 지원되는 언어 목록 및 네이티브 이름 매핑
 *
 * Gemini가 지원하는 40종 언어를 정의합니다.
 * UI 번역은 en/ko만 제공되며, 나머지 언어는 AI 요약 생성용으로만 사용됩니다.
 */

export const LANGUAGE_NAMES: Record<string, string> = {
  ar: 'العربية',
  bn: 'বাংলা',
  bg: 'Български',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
  hr: 'Hrvatski',
  cs: 'Čeština',
  da: 'Dansk',
  nl: 'Nederlands',
  en: 'English',
  et: 'Eesti',
  fi: 'Suomi',
  fr: 'Français',
  de: 'Deutsch',
  el: 'Ελληνικά',
  he: 'עברית',
  hi: 'हिन्दी',
  hu: 'Magyar',
  id: 'Bahasa Indonesia',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  lv: 'Latviešu',
  lt: 'Lietuvių',
  no: 'Norsk',
  pl: 'Polski',
  pt: 'Português',
  ro: 'Română',
  ru: 'Русский',
  sr: 'Српски',
  sk: 'Slovenčina',
  sl: 'Slovenščina',
  es: 'Español',
  sw: 'Kiswahili',
  sv: 'Svenska',
  th: 'ไทย',
  tr: 'Türkçe',
  uk: 'Українська',
  vi: 'Tiếng Việt',
  ms: 'Bahasa Melayu',
};

/**
 * 지원되는 언어 코드 타입
 */
export type LanguageCode = keyof typeof LANGUAGE_NAMES;

/**
 * 언어 코드에 대한 네이티브 이름을 반환합니다.
 *
 * @param code - 언어 코드 (예: 'ko', 'ja', 'es')
 * @returns 네이티브 언어 이름 (예: '한국어', '日本語', 'Español')
 *          지원하지 않는 코드는 그대로 반환 (fallback)
 */
export function getLanguageName(code: string): string {
  return LANGUAGE_NAMES[code] || code;
}

/**
 * 모든 지원 언어 코드 배열
 */
export const SUPPORTED_LANGUAGE_CODES = Object.keys(LANGUAGE_NAMES) as LanguageCode[];
